
export default function NeoFlashQuestionProgressText({currentQuestion, totalQuestion}) {
    // Used in FlashProgressBar to display progress
    // text in both tablet and desktop modes

    // BUILD
    return (
        <div className="w-[124px] flex justify-end items-center space-x-[4px] pb-[1px] whitespace-nowrap text-[14px] font-medium leading-none">
            <span className="text-greyLight7">Question</span>
            <span className="text-greyLight9">{currentQuestion ?? "?"}</span>
            <span className="text-greyLight7">/</span>
            <span className="text-greyLight7">{totalQuestion ?? "?"}</span>
        </div>
    );
}